export const ADD_NEW_ROW = 'ADD_NEW_ROW';
export const MAIN_SELECTION_HEADING = "Main Selection";
export const ALL_CREWS = "All Crews";
